module.exports = __webpack_public_path__ + "img/gateway.7c3d0abd.png";